import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import RecentHighlights from './highlights/RecentHighlights';
import { styled } from '@mui/material/styles';
import LightbulbLineIcon from 'remixicon-react/LightbulbLineIcon';
import { theme } from 'config/theme';

function ActivityPanel() {
  return (
    <Box pb={1}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <LightbulbLineIcon size={24} color={theme.palette.custom.pirateGold} />
        <RecentHighlightTitle>Recent Highlights</RecentHighlightTitle>
      </Box>
      <RecentHighlights />
    </Box>
  );
}

const RecentHighlightTitle = styled(Typography, { label: 'RecentHighlightTitle' })(({ theme }) => ({
  color: theme.palette.custom.tuna,
  fontSize: 16,
  fontWeight: 700,
  marginLeft: 6,
}));

export const ActivityTitle = styled(Typography, { label: 'ActivityTitle' })(({ theme }) => ({
  color: theme.palette.custom.yellowishBrown,
  fontSize: 16,
  margin: 0,
  textTransform: 'capitalize',
}));

export default memo(ActivityPanel);
